
  // import dayjs from 'dayjs'
  // import utc from 'dayjs/plugin/utc'
  import initPixel from '~/mixins/initPixel'
  import { customUTCString } from '~/utils/deviceInfo'
  // Stores layout that uses the stores theme
  // dayjs.extend(utc)
  export default {
    mixins: [initPixel],
    async fetch() {
      const response = await this.$store.dispatch(
        'banner-pwa/getBannerPWA',
        this.$route.query?.banner_id
      )
      if (!response) {
        this.$router.replace('/')
      }
    },
    head() {
      const domain = `https://${this.$config.DOMAIN}`
      const fullPath = this.$route.fullPath
      return {
        title: this.pwa?.pwa_app_settings?.meta_title,
        description: this.pwa?.pwa_app_settings?.meta_desc,
        link: [{ rel: 'canonical', href: `${domain}${fullPath}` }],
        meta: [
          { name: 'author', content: this.$config.DOMAIN },
          {
            hid: 'og:title',
            name: 'og:title',
            content: this.pwa?.pwa_app_settings?.meta_title
          },
          {
            hid: 'og:description',
            name: 'og:description',
            content: this.pwa?.pwa_app_settings?.meta_desc
          },
          {
            hid: 'og:url',
            name: 'og:url',
            content: `${domain}${fullPath}`
          }
        ]
      }
    },
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      appIcon() {
        if (!this.pwa?.pwa_app_settings?.app_icon) return null
        return `${this.$config.BUCKET_ROOT}/assets/banners/app_icons/${this.pwa?.pwa_app_settings?.app_icon}`
      }
    },
    mounted() {
      this.faviconIcon()
      this.$store.dispatch(
        'themes/language-string/fetchLanguageStrings',
        this.pwa.pwa_app_settings?.language || 'en-US'
      )
      if (this.$route.query?.banner_id) {
        const utcTime = customUTCString()
        this.handleCookie('banner_id', this.$route.query?.banner_id)
        this.handleCookie(
          `x-direct-banner-id-${this.$route.query?.banner_id}`,
          `${this.$route.query?.banner_id}|${utcTime}`
        )
      }
      if (this.$route.query?.px_id) {
        this.handleCookie('px_id', this.$route.query?.px_id)
      }
      if (this.$route.query?.ad_type) {
        this.handleCookie('ad_type', this.$route.query?.ad_type)
      }
    },
    methods: {
      faviconIcon() {
        if (this.appIcon) {
          this.$nuxt.$options.head.link.push({
            rel: 'icon',
            type: 'image/x-png',
            href: this.appIcon
          })
          this.$nuxt.$options.head.link.push({
            rel: 'apple-touch-icon',
            type: 'image/x-png',
            href: this.appIcon
          })
        }
      }
    }
  }
